import { Component, OnInit, HostListener } from '@angular/core';
import { forkJoin, Observable, Subject } from 'rxjs';

import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { InteractionResultsComponent } from '../../components/interaction-results/interaction-results.component';
import { ModalExecuteInteractionComponent, ExecuteOptions } from '../../components/modal-execute-interaction/modal-execute-interaction.component';

import {
  faArrowLeft,
  faFolderOpen,
  faDownload,
  faUpload,
  faSave,
  faPlay,
  faList,
  faSliders,
  faQuestion,
  faTimes,
  faExpand,
  faWandMagicSparkles,
  faLayerGroup
} from '@fortawesome/free-solid-svg-icons';

import { TabsComponent, TabItem } from '../../components/tabs/tabs.component';
import { InteractionModelEditorComponent } from '../../components/interaction-model-editor/interaction-model-editor.component';
import { ModalDeleteConfirmComponent } from '../../components/modal-delete-confirm/modal-delete-confirm.component';

import { ActivatedRoute, Router } from '@angular/router';
import { ViewerComponent } from '../../components/viewer/viewer.component';
import { Archive, ArchivesService } from '../../services/archives.service';
import { ReferencesService, ReferenceItem } from '../../services/references.service';
import { ModalInteractionArchivesAddComponent } from '../../components/modal-interaction-archives-add/modal-interaction-archives-add.component';
import { ModalFileGroupsComponent } from '../../components/modal-file-groups/modal-file-groups.component';
import { FileGroupsService, FileGroup } from '../../services/file-groups.service';
import { AlertService } from '../../components/alert-service/alert-service';
import { InteractionsService } from '../../services/interactions.service';
import { ModelsService, Model, ClassificationItem } from '../../services/models.service';
import { UsersService } from '../../services/users.service';
import { ModelImportExportService } from '../../services/model-import-export.service';
import { ConfigurationsService, Configuration } from '../../services/configurations.service';
import { ResultsService } from '../../services/results.service';
import { PreviewCacheService, PreviewMetadata } from '../../services/preview-cache.service';
import { ModalHelpComponent } from '../../components/modal-help/modal-help.component';
import { ChatAssistantComponent } from '../../components/chat-assistant/chat-assistant.component';
import { ModalConfirmComponent } from '../../components/modal-confirm/modal-confirm.component';
import { CanComponentDeactivate } from '../../interfaces/can-component-deactivate.interface';
import { AssistantTriggerComponent } from '../../components/assistant-trigger/assistant-trigger.component';
import { AssistantService } from '../../services/assistant.service';
import { TenantService } from '../../services/tenant.service';
import { TruncateMiddlePipe } from '../../pipes/truncate-middle.pipe';
import { SimulationFormShellComponent } from '../../components/simulation-form-shell/simulation-form-shell.component';

@Component({
  selector: 'app-interactions-form',
  standalone: true,
  imports: [
    FormsModule,
    FontAwesomeModule,
    TranslateModule,
    TabsComponent,
    InteractionModelEditorComponent,
    ModalInteractionArchivesAddComponent,
    ModalFileGroupsComponent,
    ModalExecuteInteractionComponent,

    InteractionResultsComponent,
    ViewerComponent,
    ModalHelpComponent,
    NgSelectModule,
    ChatAssistantComponent,
    ModalDeleteConfirmComponent,
    ModalConfirmComponent,
    TruncateMiddlePipe,
    AssistantTriggerComponent,
    SimulationFormShellComponent
],
  templateUrl: './interactions-form.component.html',
  styleUrls: ['./interactions-form.component.scss']
})
export class InteractionsFormComponent implements OnInit, CanComponentDeactivate {
  hasChanges: boolean = false;

  showLeaveModal = false;
  private leaveSubject: Subject<boolean> | null = null;

  faArrowLeft = faArrowLeft;
  faFolderOpen = faFolderOpen;
  faDownload = faDownload;
  faUpload = faUpload;
  faSave = faSave;
  faPlay = faPlay;

  faList = faList;
  faSliders = faSliders;
  faQuestion = faQuestion;
  faTimes = faTimes;
  faExpand = faExpand;
  faWandMagicSparkles = faWandMagicSparkles;
  faLayerGroup = faLayerGroup;

  interactionName = 'Nome da interação';
  archives: Archive[] = [];
  selectedFile: string | number | null = null;
  viewerImgIndex: number = 0;
  showModal: boolean = false;
  showFileGroupsModal: boolean = false;
  fileGroups: FileGroup[] = [];
  private archivesInitialLoadDone = false;
  imageUrls: string[] = [];
  previewMetadata: PreviewMetadata | null = null;
  previewBatchLoading = false;

  showViewerModal: boolean = false;
  showExecuteModal: boolean = false;

  mainTabs: TabItem[] = [];
  activeMainTabId: string = 'edit';
  modelTabs: TabItem[] = [];
  activeModelTabId: string = 'basic';

  models: Model[] = [];
  modelsByType: Model[] = [];
  selectedModelId: string | null = null;
  selectedModelType: 'extraction' | 'classification' = 'extraction';
  newModelName = '';

  showDeleteModelModal = false;
  modelToDelete: { id: string; name: string } | null = null;
  modelDeleteImpactItems: string[] = [];
  modelDeleteForceLabel = '';
  modelDeleteForceWarning = '';
  classificationInitial: ClassificationItem[] = [];
  classificationData: ClassificationItem[] = [];

  basicUserListInitial: any = null;
  generalRulesInitial: any = null;
  generalQuestionsInitial: any = null;

  basicUserList: any = null;
  generalRulesData: any = null;
  generalQuestionsData: any = null;
  selectedReferencesIds: string[] = [];
  allReferences: any[] = [];

  mentionData: string[] = [];

  selectedDi2winocrServer: string = '';
  selectedDi2winocrFeatures: string = '';
  selectedDelfosLlm: string = '';
  selectedDelfosServer: string = '';
  interactionId: string = '';
  loadedInteraction: any = null;

  loadingConfigurations = false;
  allConfigurations: Configuration[] = [];
  di2winocrServerConfigs: Configuration[] = [];
  di2winocrFeaturesConfigs: Configuration[] = [];
  delfosLlmConfigs: Configuration[] = [];
  delfosServerConfigs: Configuration[] = [];

  loadingResults = false;
  results: any[] = [];

  showHelpModal = false;
  helpModalTitle = '';
  helpModalContent = '';
  userPreferences: any = null;
  showAssistant = false;
  loadingAssistant = false;
  forceResultsTabFromTutorial = false;

  private modelEditCounters: Record<string, number> = {};

  constructor(
    private translate: TranslateService,
    private route: ActivatedRoute,
    private router: Router,
    private interactionsService: InteractionsService,
    private archivesService: ArchivesService,
    private fileGroupsService: FileGroupsService,
    private modelsService: ModelsService,
    private alertService: AlertService,
    private importExportService: ModelImportExportService,
    private configurationsService: ConfigurationsService,
    private resultsService: ResultsService,
    private previewCache: PreviewCacheService,
    private usersService: UsersService,
    private assistantService: AssistantService,
    private referencesService: ReferencesService,
    private tenantService: TenantService
  ) {
    const state = history.state as { interactionName?: string; interactionId?: string };

    if (state?.interactionName) {
      this.interactionName = state.interactionName;
    }

    if (state?.interactionId) {
      this.interactionId = state.interactionId;
    }
  }

  ngOnInit(): void {
    this.activeMainTabId = 'edit';
    this.activeModelTabId = 'basic';

    this.modelTabs = this.getModelsTabs().map(tab => ({
      ...tab,
      label: this.translate.instant(tab.label)
    }));

    this.route.params.subscribe(params => {
      if (params['id']) {
        this.interactionId = params['id'];
      }
    });

    this.route.queryParams.subscribe((queryParams) => {
      this.forceResultsTabFromTutorial = queryParams['tutorialTab'] === 'results';
      if (this.forceResultsTabFromTutorial) {
        this.activeMainTabId = 'results';
      }
      this.updateMainTabs();
    });
    
    this.loadReferences();
    this.loadArchives();
    this.loadModels();

    this.usersService.getMe().subscribe({
      next: (response: any) => {
        this.userPreferences = response.user.preferences;
        if (this.interactionId) {
          this.loadInteractionDetails();
          this.loadConfigurations();
          this.loadResults();
        }
      },
      error: (err: any) => {
        if (this.interactionId) {
          this.loadInteractionDetails();
          this.loadConfigurations();
          this.loadResults();
        }
      }
    });
  }

  onBack() {
    this.router.navigate(this.tenantService.buildRoute('/simulations'));
  }

  getMainTabs(): TabItem[] {
    const tabs: TabItem[] = [
      { id: 'edit', label: 'INTERACTIONS.TABS.EDIT', showHelp: true }
    ];

    if (this.shouldShowConfigTab()) {
      tabs.push({ id: 'config', label: 'INTERACTIONS.TABS.CONFIG', showHelp: true });
    }

    if (this.shouldShowResultsTab()) {
      tabs.push({ id: 'results', label: 'INTERACTIONS.TABS.RESULTS', showHelp: true });
    }

    return tabs;
  }

  shouldShowConfigTab(): boolean {
    return false;
  }

  shouldShowResultsTab(): boolean {
    return this.results.length > 0 || this.forceResultsTabFromTutorial;
  }

  getModelsTabs(): TabItem[] {
    return [
      { id: 'basic',     label: 'MODELS.TABS.BASIC',     icon: this.faList,     showHelp: true },
      { id: 'rules',     label: 'MODELS.TABS.RULES',     icon: this.faSliders,  showHelp: true },
      { id: 'questions', label: 'MODELS.TABS.QUESTIONS', icon: this.faQuestion, showHelp: true },
      { id: 'references', label: 'MODELS.TABS.REFERENCES', icon: this.faFolderOpen, showHelp: true }
    ];
  }

  onFileChanged(fileId: string | number) {
    this.selectedFile = fileId;
    this.viewerImgIndex = 0;
    this.loadPreviewForSelectedArchive();
  }

  onViewerPageChange(newIndex: number) {
    this.viewerImgIndex = newIndex;
    
    const selectedArchive = this.archives.find(a => a.id === this.selectedFile);
    if (!selectedArchive) return;

    const loadedPages = this.imageUrls.length;
    const requestedPageNumber = newIndex + 1;

    if (requestedPageNumber > loadedPages) {
      const nextBatchPage = Math.ceil(requestedPageNumber / 10);
      this.loadPreviewBatch(selectedArchive.id, nextBatchPage);
    }
  }

  onOpenFileManager() {
    this.showModal = true;
  }

  closeModal(): void {
    this.showModal = false;
    this.loadArchives();
  }

  onOpenFileGroupsModal() {
    this.showFileGroupsModal = true;
  }

  onCloseFileGroupsModal() {
    this.showFileGroupsModal = false;
  }

  onFileGroupsChanged(groups: FileGroup[]) {
    this.fileGroups = groups;
  }

  private loadFileGroups(): void {
    if (!this.interactionId) {
      this.fileGroups = [];
      return;
    }

    this.fileGroupsService.list(this.interactionId).subscribe({
      next: (groups) => {
        this.fileGroups = groups;
      },
      error: () => {
        this.fileGroups = [];
      }
    });
  }

  onUploadSuccess(uploadedIds: string[]): void {
    this.showModal = false;
    this.loadArchives();
  }

  onSaveOnly() {
    const name = this.newModelName?.trim();

    if (!name) {
      this.alertService.showError(this.translate.instant('MODELS.ERRORS.NAME_REQUIRED'));
      return;
    }

    if (this.isModelNameTaken(name)) {
      this.alertService.showError(this.translate.instant('MODELS.ERRORS.DUPLICATE_NAME'));
      return;
    }

    const payload = this.buildModelPayload();

    this.modelsService.create(payload).subscribe({
      next: (newId: string) => {


        this.selectedModelId = newId;
        this.models = [
          ...this.models,
          { ...payload, id: newId }
        ];
        this.updateModelsByType();

        this.onSelectedModelChange(newId);

        this.updateInteractionModel(newId);

        this.basicUserListInitial = this.basicUserList;
        this.generalRulesInitial = this.generalRulesData;
        this.generalQuestionsInitial = this.generalQuestionsData;
        this.hasChanges = false;

        this.alertService.showSuccess(this.translate.instant('MODELS.SAVE.SUCCESS'));
      },
      error: (err) => {
        this.alertService.showError(err);
      },
    });
  }

  onSaveAndExecute() {
    const name = this.newModelName?.trim();

    if (!name) {
      this.alertService.showError(this.translate.instant('MODELS.ERRORS.NAME_REQUIRED'));
      return;
    }

    if (this.isModelNameTaken(name)) {
      this.alertService.showError(this.translate.instant('MODELS.ERRORS.DUPLICATE_NAME'));
      return;
    }

    const payload = this.buildModelPayload();

    this.modelsService.create(payload).subscribe({
      next: (newId: string) => {
        this.selectedModelId = newId;
        this.models = [
          ...this.models,
          { ...payload, id: newId }
        ];
        this.updateModelsByType();

        this.basicUserListInitial = this.basicUserList;
        this.generalRulesInitial = this.generalRulesData;
        this.generalQuestionsInitial = this.generalQuestionsData;
        this.hasChanges = false;

        this.alertService.showSuccess(this.translate.instant('MODELS.SAVE.SUCCESS'));

        this.updateInteractionModelAndExecute(newId);
      },
      error: (err) => {
        this.alertService.showError(err);
      },
    });
  }

  onExecute() {
    if (!this.interactionId) {
      this.alertService.showError(this.translate.instant('INTERACTIONS.ERRORS.INVALID'));
      return;
    }

    if (!this.archives.length) {
      this.alertService.showError(this.translate.instant('INTERACTIONS.ERRORS.NO_ARCHIVES'));
      return;
    }

    if (!this.selectedModelId) {
      this.alertService.showError(this.translate.instant('MODELS.ERRORS.SELECT_OR_SAVE'));
      return;
    }

    if (this.userPreferences?.show_advanced_options) {
      this.showExecuteModal = true;
    } else {
      this.executeDirectly();
    }
  }

  private executeDirectly() {
    const options = this.executionOptions;
    this.onConfirmExecute(options);
  }

  private updateInteractionModelAndExecute(modelId: string): void {
    if (!this.interactionId) {
      this.onExecute();
      return;
    }

    this.interactionsService.updateModel(this.interactionId, modelId).subscribe({
      next: () => {
        this.onExecute();
      },
      error: (err) => {
        this.alertService.showError(err);
      }
    });
  }

  private loadUserPreferences() {
    this.usersService.getMe().subscribe({
      next: (response: any) => {
        this.userPreferences = response.user.preferences;
      }
    });
  }

  get executionOptions(): ExecuteOptions {
    const prefs = this.userPreferences;
    return {
      delfos_server_config_id: (prefs?.default_delfos_server_config_id !== undefined) ? (prefs.default_delfos_server_config_id || null) : (this.selectedDelfosServer || null),
      delfos_llm_config_id: (prefs?.default_delfos_llm_config_id !== undefined) ? (prefs.default_delfos_llm_config_id || null) : (this.selectedDelfosLlm || null),
      di2winocr_server_config_id: (prefs?.default_di2winocr_server_config_id !== undefined) ? (prefs.default_di2winocr_server_config_id || null) : (this.selectedDi2winocrServer || null),
      di2winocr_features_config_id: (prefs?.default_di2winocr_features_config_id !== undefined) ? (prefs.default_di2winocr_features_config_id || null) : (this.selectedDi2winocrFeatures || null),
      clear_delfos_cache: prefs?.clear_delfos_cache ?? false,
      clear_di2winocr_cache: prefs?.clear_di2winocr_cache ?? false,
      use_multimodal: prefs?.use_multimodal ?? false,
      ai_model_language: prefs?.ai_model_language ?? 'pt'
    };
  }

  onMentionDataChange(ids: string[]): void {
    this.mentionData = ids;
  }

  onBasicFormChange(value: any): void {
    this.basicUserList = value;
    this.checkForChanges();
  }

  onRulesFormChange(value: any): void {
    this.generalRulesData = value;
    this.checkForChanges();
  }

  onQuestionsFormChange(value: any): void {
    this.generalQuestionsData = value;
    this.checkForChanges();
  }

  onReferencesChange(ids: string[]): void {
    this.selectedReferencesIds = ids;
    this.checkForChanges();
  }

  onClassificationFormChange(items: ClassificationItem[]): void {
    this.classificationData = items;
    this.checkForChanges();
  }

  private checkForChanges(): void {
    this.hasChanges =
      !this.deepEqual(this.basicUserList, this.basicUserListInitial) ||
      !this.deepEqual(this.generalRulesData, this.generalRulesInitial) ||
      !this.deepEqual(this.generalQuestionsData, this.generalQuestionsInitial) ||
      !this.deepEqual(this.selectedReferencesIds, this.loadedInteraction?.model?.['references'] || []);
  }

  private deepEqual(a: any, b: any): boolean {
    return JSON.stringify(a ?? null) === JSON.stringify(b ?? null);
  }

  canDeactivate(): boolean | Observable<boolean> {
    if (!this.hasChanges) {
      return true;
    }
    this.leaveSubject = new Subject<boolean>();
    this.showLeaveModal = true;
    return this.leaveSubject.asObservable();
  }

  onLeaveConfirm(): void {
    this.showLeaveModal = false;
    this.leaveSubject?.next(true);
    this.leaveSubject?.complete();
    this.leaveSubject = null;
  }

  onLeaveCancel(): void {
    this.showLeaveModal = false;
    this.leaveSubject?.next(false);
    this.leaveSubject?.complete();
    this.leaveSubject = null;
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: BeforeUnloadEvent): void {
    if (this.hasChanges) {
      event.preventDefault();
      event.returnValue = '';
    }
  }

  onArchivesChanged(): void {
    this.loadArchives();
  }

  onOpenViewerModal(): void {
    if (!this.imageUrls.length) return;
    this.showViewerModal = true;
  }

  onCloseViewerModal(): void {
    this.showViewerModal = false;
  }

  onSelectedModelChange(modelId: string | null): void {
    this.selectedModelId = modelId;

    if (modelId) {
      this.updateInteractionModel(modelId);
      this.loadModelDetails(modelId);
    } else {
      this.clearModelForm();
    }
  }

  onRequestDeleteModel(modelId: string): void {
    const model = this.models.find(m => String(m.id) === String(modelId));
    if (!model) return;

    this.modelToDelete = { id: String(model.id), name: model.name };
    this.modelDeleteImpactItems = [
      this.translate.instant('MODELS.DELETE_IMPACT.DATA'),
      this.translate.instant('MODELS.DELETE_IMPACT.TAGS'),
      this.translate.instant('MODELS.DELETE_IMPACT.BLOCKED'),
    ];
    this.modelDeleteForceLabel = this.translate.instant('MODELS.DELETE_IMPACT.FORCE_LABEL');
    this.modelDeleteForceWarning = this.translate.instant('MODELS.DELETE_IMPACT.FORCE_WARNING');
    this.showDeleteModelModal = true;
  }

  onDeleteModelConfirm(force: boolean = false): void {
    if (!this.modelToDelete) return;
    const deletedId = this.modelToDelete.id;

    this.modelsService.delete(deletedId, force).subscribe({
      next: () => {
        this.alertService.showSuccess(this.translate.instant('MODELS.DELETE.SUCCESS'));
        this.showDeleteModelModal = false;
        this.modelToDelete = null;
        if (String(this.selectedModelId) === String(deletedId)) {
          this.selectedModelId = null;
          this.clearModelForm();
        }
        this.loadModels();
      },
      error: (err) => {
        this.alertService.showError(err);
        this.showDeleteModelModal = false;
        this.modelToDelete = null;
      }
    });
  }

  onDeleteModelClose(): void {
    this.showDeleteModelModal = false;
    this.modelToDelete = null;
    this.modelDeleteImpactItems = [];
    this.modelDeleteForceLabel = '';
    this.modelDeleteForceWarning = '';
  }

  onImportModel() {
    this.importExportService
      .importFromFile()
      .then((imported) => {
        const baseName = imported.name || 'imported_model';
        this.newModelName = baseName;
        this.selectedModelType = imported.model_type;

        if (imported.model_type === 'classification') {
          this.classificationInitial = imported.user_list;
          this.classificationData = [...this.classificationInitial];
          this.basicUserListInitial = null;
          this.generalRulesInitial = null;
          this.generalQuestionsInitial = null;
          this.basicUserList = null;
          this.generalRulesData = null;
          this.generalQuestionsData = null;
          this.selectedReferencesIds = [];
        } else {
          this.classificationInitial = [];
          this.classificationData = [];
          this.basicUserListInitial =
            this.importExportService.mapUserListToFormStructure(imported.user_list);
          this.generalRulesInitial =
            this.importExportService.mapRulesToFormStructure(imported.general_rules);
          this.generalQuestionsInitial =
            this.importExportService.mapQuestionsToFormStructure(
              imported.general_questions
            );
          this.basicUserList = this.basicUserListInitial;
          this.generalRulesData = this.generalRulesInitial;
          this.generalQuestionsData = this.generalQuestionsInitial;
          this.selectedReferencesIds = [];
        }

        this.modelTabs = this.buildModelTabs(imported.model_type);
        this.activeModelTabId = imported.model_type === 'classification' ? 'classification' : 'basic';
        this.mentionData = [];

        this.alertService.showSuccess(
          this.translate.instant('MODELS.IMPORT.SUCCESS')
        );
      })
      .catch((err) => {
        if (err) {
          this.alertService.showError(err);
        }
      });
  }

  onImportReferencesCompleted(result: { referencesImported: number; fieldsCreated: number }): void {
    if (!result.fieldsCreated) {
      this.alertService.showError(this.translate.instant('IMPORT_REFERENCES_MODAL.IMPORT_ERROR'));
      return;
    }

    this.alertService.showSuccess(
      this.translate.instant('IMPORT_REFERENCES_MODAL.IMPORT_SUCCESS', {
        references: result.referencesImported,
        fields: result.fieldsCreated,
      })
    );
  }

  onExportModel() {
    if (this.selectedModelId) {
      this.modelsService.getById(this.selectedModelId).subscribe({
        next: (fullModel) => {
          try {
            this.importExportService.exportToFile(fullModel);
            this.alertService.showSuccess(
              this.translate.instant('MODELS.EXPORT.SUCCESS')
            );
          } catch (err) {
            this.alertService.showError(err);
          }
        },
        error: (err) => {
          this.alertService.showError(err);
        },
      });
      return;
    }
    try {
      const draft = this.buildModelPayload();
      this.importExportService.exportToFile(draft, draft.name || 'draft_model');
      this.alertService.showSuccess(
        this.translate.instant('MODELS.EXPORT.SUCCESS')
      );
    } catch (err) {
      this.alertService.showError(err);
    }
  }

  get files(): string[] {
    return this.archives.map(a => a.name);
  }

  private loadInteractionDetails(): void {
    if (!this.interactionId) return;

    this.interactionsService.getById(this.interactionId).subscribe({
      next: (interaction: any) => {
        this.loadedInteraction = interaction;
        this.interactionName = interaction.name || this.interactionName;

        const simType = (interaction.simulation_type as 'extraction' | 'classification') || 'extraction';
        this.selectedModelType = simType;
        this.updateModelsByType();
        this.modelTabs = this.buildModelTabs(simType);
        this.activeModelTabId = simType === 'classification' ? 'classification' : 'basic';

        this.selectedDelfosServer = interaction.delfos_server_config_id || '';
        this.selectedDelfosLlm = interaction.delfos_llm_config_id || '';
        this.selectedDi2winocrServer = interaction.di2winocr_server_config_id || '';
        this.selectedDi2winocrFeatures = interaction.di2winocr_features_config_id || '';

        if (interaction.model_id) {
          this.selectedModelId = interaction.model_id;
          this.loadModelDetails(interaction.model_id);
        }
      },
      error: (err) => {
        this.alertService.showError(err);
      }
    });
  }

  private loadArchives(): void {
    if (!this.interactionId) {
      this.archives = [];
      this.imageUrls = [];
      this.viewerImgIndex = 0;
      this.selectedFile = null;
      return;
    }

    this.loadFileGroups();

    this.interactionsService.listArchives(this.interactionId).subscribe({
      next: (interactionArchives: any[]) => {
        this.archives = (interactionArchives || []).sort((a, b) => a.name.localeCompare(b.name));

        const isFirstArchivesLoad = !this.archivesInitialLoadDone;
        this.archivesInitialLoadDone = true;

        if (!this.archives.length) {
          this.imageUrls = [];
          this.viewerImgIndex = 0;
          this.selectedFile = null;
          if (isFirstArchivesLoad) {
            setTimeout(() => { this.showModal = true; }, 0);
          }
          return;
        }

        this.selectedFile = this.archives[0]?.id || null;
        this.viewerImgIndex = 0;
        this.loadPreviewForSelectedArchive();
      },
      error: (err) => {
        this.alertService.showError(err);
        this.archives = [];
        this.imageUrls = [];
        this.viewerImgIndex = 0;
        this.selectedFile = null;
      }
    });
  }

  private loadReferences(): void {
    this.referencesService.listReferences(undefined, undefined, 1, 999).subscribe({
      next: (response: any) => {
        this.allReferences = response.references || [];
      },
      error: (err: any) => {
        this.alertService.showError(err);
      }
    });
  }

  private loadPreviewForSelectedArchive(): void {
    if (!this.selectedFile) {
      this.imageUrls = [];
      return;
    }

    const selectedArchive = this.archives.find(a => a.id === this.selectedFile);
    if (!selectedArchive) {
      this.imageUrls = [];
      return;
    }

    this.loadPreviewBatch(selectedArchive.id, 1);
  }

  private loadPreviewBatch(archiveId: string | number, page: number): void {
    if (page > 1) {
      this.previewBatchLoading = true;
    }

    this.previewCache.getPreviewPages(archiveId, page).subscribe({
      next: ({ pages, metadata }) => {
        if (page === 1) {
          this.imageUrls = pages.map(p => p.base64Data);
          this.viewerImgIndex = 0;
        } else {
          this.imageUrls = [...this.imageUrls, ...pages.map(p => p.base64Data)];
        }
        this.previewMetadata = metadata;
        this.previewBatchLoading = false;
      },
      error: (err: any) => {
        this.previewBatchLoading = false;
        this.alertService.showError(err);
        this.imageUrls = [];
        this.viewerImgIndex = 0;
      }
    });
  }

  private updateModelsByType(): void {
    this.modelsByType = this.models.filter(m => (m['model_type'] || 'extraction') === this.selectedModelType);
  }

  private loadModels(): void {
    this.modelsService.list(undefined, undefined, 1, 9999).subscribe({
      next: (response) => {
        this.models = response.models || [];
        this.updateModelsByType();

        if (!this.selectedModelId) {
          this.clearModelForm();
        }
      },
      error: (err) => {
        this.alertService.showError(err);
        this.models = [];
        this.selectedModelId = null;
      }
    });
  }

  private loadModelDetails(modelId: string): void {
    this.modelsService.getById(modelId).subscribe({
      next: (model: Model) => {
        this.applyModelToForm(model);
      },
      error: (err) => {
        this.alertService.showError(err);
      }
    });
  }

  private buildModelTabs(modelType: 'extraction' | 'classification'): TabItem[] {
    if (modelType === 'classification') {
      return [{ id: 'classification', label: this.translate.instant('MODELS.TABS.CLASSIFICATION'), icon: this.faList }];
    }
    return this.getModelsTabs().map(tab => ({ ...tab, label: this.translate.instant(tab.label) }));
  }

  private applyModelToForm(model: Model): void {
    const modelType = (model.model_type as 'extraction' | 'classification') || 'extraction';
    this.selectedModelType = modelType;
    this.newModelName = model.name;

    if (modelType === 'classification') {
      this.classificationInitial = (model.user_list as ClassificationItem[]) || [];
      this.classificationData = [...this.classificationInitial];
      this.basicUserListInitial = null;
      this.generalRulesInitial = null;
      this.generalQuestionsInitial = null;
      this.basicUserList = null;
      this.generalRulesData = null;
      this.generalQuestionsData = null;
      this.selectedReferencesIds = [];
    } else {
      this.classificationInitial = [];
      this.basicUserListInitial =
        this.importExportService.mapUserListToFormStructure(model.user_list || []);
      this.generalRulesInitial =
        this.importExportService.mapRulesToFormStructure(model.general_rules || []);
      this.generalQuestionsInitial =
        this.importExportService.mapQuestionsToFormStructure(model.general_questions || []);
      this.basicUserList = this.basicUserListInitial;
      this.generalRulesData = this.generalRulesInitial;
      this.generalQuestionsData = this.generalQuestionsInitial;
      this.selectedReferencesIds = model.references || [];
    }

    this.modelTabs = this.buildModelTabs(modelType);
    this.activeModelTabId = modelType === 'classification' ? 'classification' : 'basic';
    this.mentionData = [];
  }

  private clearModelForm(): void {
    this.classificationInitial = [];
    this.classificationData = [];
    this.newModelName = '';
    this.basicUserListInitial = null;
    this.generalRulesInitial = null;
    this.generalQuestionsInitial = null;

    this.basicUserList = null;
    this.generalRulesData = null;
    this.generalQuestionsData = null;
    this.selectedReferencesIds = [];
    this.mentionData = [];
    this.modelTabs = this.buildModelTabs(this.selectedModelType);
    this.activeModelTabId = this.selectedModelType === 'classification' ? 'classification' : 'basic';
  }

  private buildModelPayload(): Model {
    const version = '2';

    const userListArray =
      this.basicUserList
        ? this.importExportService.normalizeUserList(this.basicUserList)
        : [];

    const generalRulesArray =
      this.generalRulesData
        ? this.importExportService.normalizeGeneralRules(this.generalRulesData)
        : [];

    const generalQuestionsArray =
      this.generalQuestionsData
        ? this.importExportService.normalizeGeneralQuestions(this.generalQuestionsData)
        : [];

    if (this.selectedModelType === 'classification') {
      return {
        name: this.newModelName,
        model_type: 'classification',
        version: version,
        user_list: this.classificationData,
        general_rules: [],
        general_questions: [],
        references: []
      } as unknown as Model;
    }

    return {
      name: this.newModelName,
      version: version,
      user_list: userListArray,
      general_rules: generalRulesArray,
      general_questions: generalQuestionsArray,
      references: this.selectedReferencesIds
    } as Model;
  }

  private isModelNameTaken(name: string): boolean {
    const normalized = name.trim().toLowerCase();
    if (!normalized) return false;

    return this.models.some((m) =>
      (m.name ?? '').trim().toLowerCase() === normalized
    );
  }

  private updateInteractionModel(modelId: string): void {
    if (!this.interactionId) return;
    
    this.interactionsService.updateModel(this.interactionId, modelId).subscribe({
      error: (err) => {
        this.alertService.showError(err);
      }
    });
  }

  private loadConfigurations(): void {
    this.loadingConfigurations = true;
    this.configurationsService.listAllowedForMe().subscribe({
      next: (response) => {
        this.allConfigurations = response.configurations || [];
        this.filterConfigurationsByType();
        this.loadingConfigurations = false;
        this.updateMainTabs();
      },
      error: (err) => {
        this.alertService.showError(err);
        this.loadingConfigurations = false;
        this.allConfigurations = [];
        this.updateMainTabs();
      }
    });
  }

  private filterConfigurationsByType(): void {
    this.di2winocrServerConfigs = this.allConfigurations.filter(c => c.type === 'di2winocr_server');
    this.di2winocrFeaturesConfigs = this.allConfigurations.filter(c => c.type === 'di2winocr_features');
    this.delfosLlmConfigs = this.allConfigurations.filter(c => c.type === 'delfos_llm');
    this.delfosServerConfigs = this.allConfigurations.filter(c => c.type === 'delfos_server');

    const prefs = this.userPreferences;

    if (!this.selectedDi2winocrServer && this.di2winocrServerConfigs.length > 0) {
      this.selectedDi2winocrServer = prefs?.default_di2winocr_server_config_id || this.di2winocrServerConfigs[0].id;
    }
    if (!this.selectedDi2winocrFeatures && this.di2winocrFeaturesConfigs.length > 0) {
      this.selectedDi2winocrFeatures = prefs?.default_di2winocr_features_config_id || this.di2winocrFeaturesConfigs[0].id;
    }
    if (!this.selectedDelfosLlm && this.delfosLlmConfigs.length > 0) {
      this.selectedDelfosLlm = prefs?.default_delfos_llm_config_id || this.delfosLlmConfigs[0].id;
    }
    if (!this.selectedDelfosServer && this.delfosServerConfigs.length > 0) {
      this.selectedDelfosServer = prefs?.default_delfos_server_config_id || this.delfosServerConfigs[0].id;
    }
  }

  loadResults(): void {
    this.loadingResults = true;
    this.resultsService.listResults(this.interactionId).subscribe({
      next: (response) => {
        this.results = response.results || [];
        this.loadingResults = false;
        this.updateMainTabs();
      },
      error: (err) => {
        this.alertService.showError(err);
        this.loadingResults = false;
        this.results = [];
        this.updateMainTabs();
      }
    });
  }

  private updateMainTabs(): void {
    this.mainTabs = this.getMainTabs().map(tab => ({
      ...tab,
      label: this.translate.instant(tab.label)
    }));
  }


  onConfirmExecute(options: ExecuteOptions): void {
    this.showExecuteModal = false;
    
    if (!this.interactionId) {
      this.alertService.showError(this.translate.instant('INTERACTIONS.ERRORS.INVALID'));
      return;
    }

    if (options.save_as_default) {
      const currentPrefs = this.userPreferences || { show_advanced_options: false };
      const updatedPrefs: any = {
        ...currentPrefs,
        default_delfos_server_config_id: options.delfos_server_config_id || '',
        default_delfos_llm_config_id: options.delfos_llm_config_id || '',
        default_di2winocr_server_config_id: options.di2winocr_server_config_id || '',
        default_di2winocr_features_config_id: options.di2winocr_features_config_id || '',
        ai_model_language: options.ai_model_language || 'pt',
        clear_delfos_cache: options.clear_delfos_cache,
        clear_di2winocr_cache: options.clear_di2winocr_cache
      };

      this.usersService.updatePreferences(updatedPrefs).subscribe({
        next: (response: any) => {
          this.userPreferences = response?.preferences || updatedPrefs;
          if (this.userPreferences) {
            this.selectedDelfosServer = this.userPreferences.default_delfos_server_config_id || '';
            this.selectedDelfosLlm = this.userPreferences.default_delfos_llm_config_id || '';
            this.selectedDi2winocrServer = this.userPreferences.default_di2winocr_server_config_id || '';
            this.selectedDi2winocrFeatures = this.userPreferences.default_di2winocr_features_config_id || '';
          }
        }
      });
    }

    if (options.batch_ids && options.batch_ids.length > 0) {
      this.executeBatch(options, options.batch_axis!, options.batch_ids);
      return;
    }

    this.interactionsService.execute(this.interactionId, options).subscribe({
      next: () => {
        this.alertService.showSuccess(this.translate.instant('INTERACTIONS.EXECUTE.SUCCESS'));
        this.loadResults();
        this.activeMainTabId = 'results';
      },
      error: (err) => {
        this.alertService.showError(err);
      }
    });
  }

  private executeBatch(baseOptions: ExecuteOptions, axis: 'delfos_llm_config_id' | 'di2winocr_features_config_id', ids: string[]): void {
    const { batch_axis, batch_ids, save_as_default, ...rest } = baseOptions;
    const requests = ids.map(id => this.interactionsService.execute(this.interactionId, { ...rest, [axis]: id }));

    forkJoin(requests).subscribe({
      next: () => {
        this.alertService.showSuccess(this.translate.instant('INTERACTIONS.EXECUTE.BATCH_SUCCESS', { count: ids.length }));
        this.loadResults();
        this.activeMainTabId = 'results';
      },
      error: (err) => {
        this.alertService.showError(err);
        this.loadResults();
        this.activeMainTabId = 'results';
      }
    });
  }

  onCloseExecuteModal(): void {
    this.showExecuteModal = false;
  }

  onHelpClicked(tabId: string): void {
    const helpMap: Record<string, { title: string; content: string }> = {
      'edit': {
        title: 'HELP.INTERACTIONS.EDIT.TITLE',
        content: 'HELP.INTERACTIONS.EDIT.CONTENT'
      },
      'config': {
        title: 'HELP.INTERACTIONS.CONFIG.TITLE',
        content: 'HELP.INTERACTIONS.CONFIG.CONTENT'
      },
      'results': {
        title: 'HELP.INTERACTIONS.RESULTS.TITLE',
        content: 'HELP.INTERACTIONS.RESULTS.CONTENT'
      }
    };

    const help = helpMap[tabId];
    if (help) {
      this.helpModalTitle = help.title;
      this.helpModalContent = help.content;
      this.showHelpModal = true;
    }
  }

  onModelHelpClicked(tabId: string): void {
    const helpMap: Record<string, { title: string; content: string }> = {
      'basic': {
        title: 'MODELS.TABS.BASIC',
        content: 'INTERACTION_MODEL_EDITOR.BASIC'
      },
      'rules': {
        title: 'MODELS.TABS.RULES',
        content: 'INTERACTION_MODEL_EDITOR.GENERAL_RULES'
      },
      'questions': {
        title: 'MODELS.TABS.QUESTIONS',
        content: 'INTERACTION_MODEL_EDITOR.GENERAL_QUESTIONS'
      },
      'references': {
        title: 'MODELS.TABS.REFERENCES',
        content: 'INTERACTION_MODEL_EDITOR.REFERENCES'
      }
    };

    const help = helpMap[tabId];
    if (help) {
      this.helpModalTitle = help.title;
      this.helpModalContent = help.content;
      this.showHelpModal = true;
    }
  }

  onCloseHelpModal(): void {
    this.showHelpModal = false;
  }

  onOpenAssistant(): void {
    this.showAssistant = true;
  }

  onCloseAssistant(): void {
    this.showAssistant = false;
  }

  onAssistantResult(event: { archive_id: string; archive_ids?: string[]; language: string; clear_delfos_cache: boolean; clear_di2winocr_cache: boolean; ocr_features_config_id?: string; delfos_llm_config_id?: string }): void {
    this.loadingAssistant = true;
    const task = this.selectedModelType === 'classification' ? 'classify' : 'extraction';
    const ids = event.archive_ids && event.archive_ids.length > 0 ? event.archive_ids : [event.archive_id];

    this.assistantService.generateModel(ids, task, event.language, event.clear_delfos_cache, event.clear_di2winocr_cache, event.ocr_features_config_id, event.delfos_llm_config_id).subscribe({
      next: (result) => {
        this.loadingAssistant = false;
        if (result.error) {
          this.alertService.showError(this.translate.instant('ASSISTANT.ERROR_GENERATING'));
          return;
        }
        this.showAssistant = false;

        if (this.selectedModelType === 'classification') {
          const newClass: ClassificationItem = {
            id: result.id || 'Nova Classe',
            description: result.description || '',
            examples: Array.isArray(result.examples) ? result.examples.map((ex: any) => String(ex ?? '')) : []
          };
          this.classificationInitial = [...this.classificationData, newClass];
          this.classificationData = [...this.classificationInitial];
        } else {
          this.basicUserListInitial = this.importExportService.mapUserListToFormStructure(result.wishList || []);
          this.generalRulesInitial = this.importExportService.mapRulesToFormStructure(result.generalRules || []);
          this.generalQuestionsInitial = this.importExportService.mapQuestionsToFormStructure(result.generalQuestions || []);

          this.basicUserList = this.basicUserListInitial;
          this.generalRulesData = this.generalRulesInitial;
          this.generalQuestionsData = this.generalQuestionsInitial;
        }

        this.mentionData = [];
        this.alertService.showSuccess(this.translate.instant('ASSISTANT.SUCCESS'));
      },
      error: () => {
        this.loadingAssistant = false;
        this.alertService.showError(this.translate.instant('ASSISTANT.ERROR_GENERATING'));
      }
    });
  }
}